export default __webpack_public_path__ + "media/zurb/img/blog/blogpost-screenshot1-2020de06c47737b18faf6d76ffe8eb03.png";